module.exports = __webpack_public_path__ + "img/901540966.67c07ddf.png";